module.exports = __webpack_public_path__ + "static/img/news6-cover.2791f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news6-cover.jpg
// module id = 78MB
// module chunks = 0